/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.outPlanMaster.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
